import React, { memo } from 'react'
import { Icon } from 'antd'
import VideoPlayer from '../../../../../../components/VideoPlayer'

const VideoView = ({
  url,
  poster = '',
  isVisible,
  volume,
  showVolume = true,
  height = '250px'
}) => {
  if (!isVisible) {
    return (
      <div
        style={{
          width: '100%',
          height,
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999'
        }}
      >
        <Icon type="play-circle" style={{ fontSize: '48px' }} />
      </div>
    )
  }

  return (
    <div style={{ width: '100%', height }}>
      <VideoPlayer
        poster={poster}
        src={url}
        showVolume={showVolume}
        controlledVolume={volume}
      />
    </div>
  )
}

// CRITICAL: Only re-render VideoPlayer if URL or visibility changes
export default memo(VideoView, (prevProps, nextProps) => {
  return (
    prevProps.url === nextProps.url &&
    prevProps.isVisible === nextProps.isVisible &&
    prevProps.volume === nextProps.volume &&
    prevProps.poster === nextProps.poster &&
    prevProps.showVolume === nextProps.showVolume &&
    prevProps.height === nextProps.height
  )
})
